export default __webpack_public_path__ + "static/media/hidraulic18.83fa530a.jpg";